import { cn } from '@forest/shared'
import { Spinner } from '~/components/spinner'

export function LoadingOverlay(props: { isLoading: boolean }) {
  return (
    <div
      class={cn(
        'pointer-events-none fixed inset-0 flex items-center justify-center transition-opacity duration-300',
        props.isLoading ? 'opacity-100' : 'opacity-0',
      )}
    >
      <Spinner />
    </div>
  )
}
